export const merchantMutations = {
  setCurrentMerchantItems(state, payload) {
    state.setCurrentMerchantItems = payload;
  },
  setCurrentMerchant(state, payload) {
    state.currentMerchant = payload;
  },
  setCurrentMerchantObject(state, payload) {
    state.currentMerchantObject = payload;
  },
  setCompanyTypeGroups(state, payload) {
    state.companyTypeGroups = payload;
  },
  setMerchantMessages(state, payload) {
    state.merchantMessages = payload;
  },
  setMerchantInformation(state, payload) {
    state.merchantInformation = payload;
  },
  setMerchantStatusList(state, payload) {
    state.merchantStatusList = payload
  },
  setMerchantIsManufacturer(state, payload) {
    state.merchantIsManufacturer = payload
  }
};